var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import PersonIcon from "@mui/icons-material/Person";
import { Avatar, Box, Tooltip } from "@mui/material";
import { getScaledUrl, MediaSize } from "../../utils/media.util";
import { getInitials, getProfileAvatarColors } from "./profileIdentity.util";
var CenteredCaps = function (_a) {
    var children = _a.children;
    return (_jsx(Box, __assign({ component: 'span', sx: { position: 'relative', top: '0.09em' } }, { children: children })));
};
var resolveDimensions = function (size) {
    switch (size) {
        case 'xs':
            return { diameter: 20, borderWidth: 1.5, padding: 1, fontSize: 10, badgeDiameter: 14 };
        case 'large':
            return { diameter: 72, borderWidth: 3, padding: 3, fontSize: 22, badgeDiameter: 24 };
        case 'small':
        default:
            return { diameter: 40, borderWidth: 2, padding: 2, fontSize: 14, badgeDiameter: 20 };
    }
};
var ProfileAvatar = function (_a) {
    var profile = _a.profile, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.completedStays, completedStays = _c === void 0 ? 0 : _c, completedStaysLabel = _a.completedStaysLabel;
    var colors = getProfileAvatarColors(profile);
    var _d = resolveDimensions(size), diameter = _d.diameter, borderWidth = _d.borderWidth, padding = _d.padding, fontSize = _d.fontSize, badgeDiameter = _d.badgeDiameter;
    var isExtraSmall = size === 'xs';
    var shouldShowBadge = !isExtraSmall && completedStays > 0;
    var initials = getInitials(profile);
    var avatarUrl = profile.avatar
        ? getScaledUrl(profile.avatar, diameter > 48 ? MediaSize.MEDIUM_300 : MediaSize.SMALL_64, diameter > 48 ? MediaSize.MEDIUM_300 : MediaSize.SMALL_64) || undefined
        : undefined;
    var badge = shouldShowBadge ? (_jsx(Box, __assign({ "aria-label": completedStaysLabel, sx: {
            position: 'absolute',
            right: diameter >= 72 ? -4 : -3,
            bottom: diameter >= 72 ? -2 : -3,
            minWidth: badgeDiameter,
            height: badgeDiameter,
            boxSizing: 'border-box',
            px: diameter >= 72 ? '6px' : '4px',
            borderRadius: "".concat(badgeDiameter / 2, "px"),
            border: '2px solid #FFFFFF',
            bgcolor: colors.badge,
            color: '#FFFFFF',
            fontSize: Math.max(10, Math.round(badgeDiameter * 0.55)),
            fontWeight: 700,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            userSelect: 'none',
            boxShadow: '0 1px 3px rgba(0,0,0,0.18)'
        } }, { children: _jsx(CenteredCaps, { children: completedStays }) }))) : null;
    return (_jsxs(Box, __assign({ sx: {
            position: 'relative',
            width: diameter,
            height: diameter,
            flexShrink: 0
        } }, { children: [_jsx(Box, __assign({ sx: {
                    width: diameter,
                    height: diameter,
                    boxSizing: 'border-box',
                    borderRadius: '50%',
                    border: "".concat(borderWidth, "px solid ").concat(colors.ring),
                    padding: "".concat(padding, "px")
                } }, { children: _jsx(Avatar, __assign({ src: avatarUrl, sx: {
                        width: '100%',
                        height: '100%',
                        bgcolor: colors.fill,
                        color: colors.ink,
                        fontSize: fontSize,
                        fontWeight: 600,
                        userSelect: 'none'
                    } }, { children: isExtraSmall && initials === '?' ? (_jsx(PersonIcon, { sx: { fontSize: Math.round(diameter * 0.65) } })) : (_jsx(CenteredCaps, { children: initials })) })) })), badge && (completedStaysLabel ? _jsx(Tooltip, __assign({ title: completedStaysLabel, arrow: true }, { children: badge })) : badge)] })));
};
export default ProfileAvatar;
